import { ContentCardItem } from '@/lib/types/content';

export const CONTENT_CARD_PAGE_PER_COUNT = 10;

export const CARE_ADVERTISEMENT_CARD: ContentCardItem[] = [
  {
    overText: '세금 폭탄 피하세요',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '절세 전문 세무기장,\n오늘 신청 시 월 3만원!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-care-0',
    backgroundColorClass: 'bg-[#5e50fa]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/care/logos/logo-bznav-care-white.svg`,
    link: 'https://ac.bznav.com/n4p4sl'
  },
  {
    overText: '세무기장은 비즈넵 케어',
    title: '월 3만원에 맡겼더니,\n세금 고민 사라졌어요!',
    type: 'advertisement',
    backgroundImageClass: 'bz-care-1',
    backgroundColorClass: 'bg-[#f4f4ff]',
    link: 'https://ac.bznav.com/yfusgb'
  },
  {
    overText: '사장님 질문 모음 ZIP',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '사업장에 맞는\n공제 방법이 궁금해요!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-care-2',
    backgroundColorClass: 'bg-[#3a8cff]',
    link: 'https://ac.bznav.com/4enafs'
  }
];

export const REFUND_ADVERTISEMENT_CARD: ContentCardItem[] = [
  {
    overText: '세금 환급 브랜드 1위, 비즈넵',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '평균 환급금 960만원\n지금 바로 확인해보세요!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-0',
    backgroundColorClass: 'bg-[#3a8cff]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/aer70e'
  },
  {
    overText: '사업자 평균 960만원 수령 중',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '이번 달 숨은 환급금,\n지금 확인 안하면 손해!',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-1',
    backgroundColorClass: 'bg-[#2f4bda]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/rp7jdw'
  },
  {
    overText: '사장님 질문 모음 ZIP',
    overTextColorClass: 'text-gray-alpha-inverse-500',
    title: '숨은 환급금,\n저도 대상자인가요?',
    titleColorClass: 'text-neutral-foreground-inverse-main',
    type: 'advertisement',
    backgroundImageClass: 'bz-refund-2',
    backgroundColorClass: 'bg-[#2f4bda]',
    complianceLogo: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/logos/logo-bznav-refund-white.svg`,
    link: 'https://ab.bznav.com/l5r3f4'
  }
];

export const QUESTION_CARD_COLOR_CLASS: Pick<ContentCardItem, 'backgroundColorClass' | 'overTextColorClass' | 'titleColorClass'>[] = [
  { backgroundColorClass: 'bg-gray-100', overTextColorClass: 'text-gray-alpha-500', titleColorClass: 'text-neutral-foreground-main' },
  { backgroundColorClass: 'bg-blue-600', overTextColorClass: 'text-gray-alpha-inverse-500', titleColorClass: 'text-neutral-foreground-inverse-main' },
  { backgroundColorClass: 'bg-violet-100', overTextColorClass: 'text-gray-alpha-500', titleColorClass: 'text-neutral-foreground-main' },
  { backgroundColorClass: 'bg-gray-900', overTextColorClass: 'text-gray-alpha-inverse-500', titleColorClass: 'text-neutral-foreground-inverse-main' }
];

export const LOGO_EXPERTS: Record<string, string> = {
  지수회계법인: '/logos/expert/zsoo.svg',
  나이스노무법인: '/logos/expert/nice.svg',
  투모로법무사강남사무소: '/logos/expert/tomolaw.svg',
  카이특허법인: '/logos/expert/kai.svg',
  법무법인웨이브: '/logos/expert/wave.svg',
  변호사정선화법률사무소: '/logos/expert/sunhwa.png'
};

export const LOADING_TEXTS = ['세나가 최상의 답변을 준비 중이에요', '관련 조문과 판례, 사례를 찾고 있어요', '곧 답변 드릴게요! 조금만 기다려 주세요'];
